import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export type CalendarIntegrationStatus = {
  integrated: boolean
  providers: string[]
}

export const getCalendarIntegrationStatus: QueryFn<[string], CalendarIntegrationStatus | undefined> = async client => {
  const { data } = await client.get<CalendarIntegrationStatus>('v1/giving-calendars/auth/integration-status', {
    withCredentials: true
  })

  return data
}
